import { apiRequest } from './api';

// ── Types ───────────────────────────────────────────────────

export type FeeStructureComponentRecord = {
    id: string;
    fee_structure_id: string;
    fee_head_id: string;
    amount: string;
    created_at: string;
    updated_at: string;
    fee_head?: { id: string; name: string; type: string | null };
};

export type FeeStructureRecord = {
    id: string;
    organization_id: string;
    school_id: string;
    academic_session_id: string;
    class_id: string;
    total_amount: string;
    due_date: string | null;
    is_active: boolean;
    metadata: Record<string, unknown> | null;
    created_at: string;
    updated_at: string;
    components?: FeeStructureComponentRecord[];
};

export type CreateFeeStructurePayload = {
    school_id: string;
    academic_session_id: string;
    class_id: string;
    total_amount: number;
    due_date?: string | null;
    is_active?: boolean;
};

export type AddComponentPayload = {
    fee_head_id: string;
    amount: number;
};

// ── API Functions ───────────────────────────────────────────

export async function fetchFeeStructures(params?: {
    school_id?: string;
    academic_session_id?: string;
}): Promise<FeeStructureRecord[]> {
    const query = new URLSearchParams();
    if (params?.school_id) query.set('school_id', params.school_id);
    if (params?.academic_session_id) query.set('academic_session_id', params.academic_session_id);
    const qs = query.toString();
    const res = await apiRequest<FeeStructureRecord[]>(`/api/fee-structures${qs ? `?${qs}` : ''}`);
    return res.data;
}

export async function createFeeStructure(payload: CreateFeeStructurePayload): Promise<FeeStructureRecord> {
    const res = await apiRequest<FeeStructureRecord>('/api/fee-structures', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return res.data;
}

export async function addFeeStructureComponent(
    feeStructureId: string,
    payload: AddComponentPayload
): Promise<FeeStructureComponentRecord> {
    const res = await apiRequest<FeeStructureComponentRecord>(
        `/api/fee-structures/${feeStructureId}/components`,
        { method: 'POST', body: JSON.stringify(payload) }
    );
    return res.data;
}

export async function updateFeeStructureComponent(
    componentId: string,
    payload: { amount: number }
): Promise<FeeStructureComponentRecord> {
    const res = await apiRequest<FeeStructureComponentRecord>(
        `/api/components/${componentId}`,
        { method: 'PATCH', body: JSON.stringify(payload) }
    );
    return res.data;
}

export async function deleteFeeStructureComponent(componentId: string): Promise<void> {
    await apiRequest(`/api/components/${componentId}`, { method: 'DELETE' });
}
